import { TeamEditForm } from '@/modules/team/views/edit/team-edit-form.tsx'
import { TeamEditPageSkeleton } from '@/modules/team/views/edit/team-edit-skeleton.tsx'

import { useRoles } from '../../hooks/use-roles'
import { useTeamMember } from '../../hooks/use-team-member'
import { useTeamPermissions } from '../../hooks/use-team-permissions'

export const TeamEdit = ({ id }: { id: string }) => {
  const { data, permissions, isSuccess: isSucessMember } = useTeamMember(id)
  const { data: roles, isSuccess: isSuccessRoles } = useRoles()
  const { isSuccess: isSuccessMemberPermissions } = useTeamPermissions()

  if (!(isSuccessRoles && isSucessMember && isSuccessMemberPermissions)) {
    return <TeamEditPageSkeleton />
  }

  if (!data || !roles || !permissions) {
    return <span>No data found.</span>
  }

  return (
    <TeamEditForm
      data={data}
      permissions={permissions}
      roles={roles}
    />
  )
}
